module.exports = __webpack_public_path__ + "img/231.78c79223.jpg";